"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dist = require("package_ui_ihm/dist");
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : help.js
* Description : Ce fichier contient la définition de la page help 
*               Cette page contient un glossaire des terme utilisés dans l'application
* Date de création : 19 janvier 2026
*/ /* CSS et assets */ // None
/* Bibliothèques et composants */ /* Hook */ /**
* UserList : affiche la page d'aide qui contient un glossaire
*            Affichage de la définition en fonction du terme sélectionné
*
* Type : page 
*
* Parametres : 
*  None
*/
function Help() {
  // Define glossary list
  var glossary = [{
    "id": 0,
    "word": "Traitement et phases ",
    "definition": [{
      "text": "Chaque produit client contient des traitements boxilumix définis selon le besoin du client pour traiter des cibles avec un objectif précis.",
      "format": ""
    }, {
      "text": "-> Les phases de traitements : ",
      "format": "glossary-subtitle"
    }, {
      "text": "Lors de la réalisation du traitement sur le produit client, les temps d'activation des leds pour traiter la cible sont paramètrables.",
      "format": ""
    }, {
      "text": "Ces temps d'activation des Leds sont désignés comme une phase de traitement dont la date de début et de fin est consultable ensuite sur l'application Boxilumix.",
      "format": ""
    }, {
      "text": "-> Les types de traitement : ",
      "format": "glossary-subtitle"
    }, {
      "text": "Les types de traitements sont différenciés selon l'objectif du traitement. Exemple : traitement de préservation, traitement de coloration, traitement de décontamination, etc",
      "format": ""
    }]
  }, {
    "id": 1,
    "word": "Définition d'une cible",
    "definition": [{
      "text": "Une cible correspond à un élément qui doit recevoir le traitement. Lors d'un traitement, celui-ci est généralement appliqué à un ensemble de cible.",
      "format": ""
    }, {
      "text": "-> Comment est identifiée une cible ?",
      "format": "glossary-subtitle"
    }, {
      "text": "Une cible est identifiée par les trois attributs suivants :",
      "format": ""
    }, {
      "text": "- Un type de cible parmi les choix suivants : arbre, fleur, fruits et légumes, semences, plants, et autre. Le type 'autre' peut regrouper des éléments autre que végétal (boite de pétri, viande, matériel...)",
      "format": "glossary-list"
    }, {
      "text": "- Une catégorie qui correpond généralement à une espèce végétale",
      "format": "glossary-list"
    }, {
      "text": "- Une variété qui est un sous ensemble de la catégorie",
      "format": "glossary-list"
    }]
  }];

  // Define useState hooks
  var _useState = (0, _react.useState)({
      "word": "",
      "definition": [""]
    }),
    _useState2 = _slicedToArray(_useState, 2),
    currentChoice = _useState2[0],
    setCurrentChoice = _useState2[1];

  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Define functions
  var handleClick = function handleClick(event, word) {
    event.preventDefault();
    var choice = glossary.find(function (item) {
      return word === item['word'];
    });
    setCurrentChoice(choice);
  };

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.TabC, {
      tabNumber: 5
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: screenWidth > 650 ? 'App' : 'App-ss',
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dist.Container, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
            children: "Glossaire"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: screenWidth > 650 ? 'grid-1-3' : null,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "scroll-list-c",
            children: glossary && glossary.length !== 0 ? glossary.sort(function (a, b) {
              return a['word'] > b['word'] ? 1 : -1;
            }).map(function (item) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.Item, {
                id: item['id'],
                className: "form-side-label",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  onClick: function onClick(e) {
                    return handleClick(e, item['word']);
                  },
                  children: item['word']
                })
              }, item['id']);
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              children: "Erreur !"
            })
          }), screenWidth > 650 ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "glossary",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
              children: currentChoice['word']
            }), currentChoice['definition'].map(function (text) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                className: text['format'],
                children: text['text']
              });
            })]
          })]
        })]
      })
    })]
  });
}
var _default = exports["default"] = Help;